import "./TradingIdeasRiskComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {TradingIdeasViewStore} from "../../store/TradingIdeasViewStore";
import {ReplaySubject, Scheduler} from "rxjs";
import {TradeIdeaRiskViewModel} from "../../models/TradeIdeaRiskViewModel";

export const TradingIdeasRisk = "tfTradingIdeasRisk";

export function tradingIdeasReward(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/risk/TradingIdeasRiskComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: TradingIdeasRiskComponentController
    };
}

export class TradingIdeasRiskComponentController implements IOnInit, IOnDestroy {

    /** @Input */
    public readonly store: TradingIdeasViewStore;

    public readonly maxReward$ = new ReplaySubject<number>(1);
    public readonly maxRisk$ = new ReplaySubject<number>(1);

    /* Have to be variables since the slider isn't nice */
    public sliderValue: number;
    public sliderOptions: RzSliderOptions;

    private readonly valueChanged$ = new ReplaySubject<number>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $scope: IScope) {

    }

    public $onInit(): void {
        this.watchRiskChange();
        this.watchRewardChange();
        this.watchModelChange();
        this.watchValueChange();
    }

    private watchRiskChange() {
        this.store
            .currentRisk
            .takeUntil(this.destroyed$)
            .observeOn(Scheduler.async)
            .map((model) => model.currentRisk)
            .subscribe((risk) => this.maxRisk$.next(risk));
    }

    private watchRewardChange() {
        this.store
            .currentRisk
            .takeUntil(this.destroyed$)
            .observeOn(Scheduler.async)
            .map((model) => model.currentPayoff)
            .subscribe((payoff) => this.maxReward$.next(payoff));
    }

    private watchModelChange() {
        this.store
            .currentRisk
            .takeUntil(this.destroyed$)
            .observeOn(Scheduler.async)
            .subscribe((model) => {
                this.$scope.$applyAsync(() => {
                    this.sliderValue = model.currentLots;
                    this.sliderOptions = this.buildSliderOptions(model);
                });
            });
    }

    private buildSliderOptions(model: TradeIdeaRiskViewModel): RzSliderOptions {
        return {
            floor: model.minimumLots,
            ceil: model.maximumLots,
            step: model.lotsStepSize,
            hideLimitLabels: true,
            hidePointerLabels: true,
            translate: () => "", // Just to remove the "current value" label above the slider
            onChange: (_, value) => this.valueChanged$.next(value)
        };
    }

    private watchValueChange() {
        this.valueChanged$
            .takeUntil(this.destroyed$)
            .observeOn(Scheduler.async)
            .auditTime(100)
            .map((value) => Math.round(value))
            .subscribe((lots) => this.store.updateLots(lots));
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
